import Icon from "react-crypto-icons";
import { Cell, Label, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import AnalyticsTooltip from "src/components/Referral-partner/Analytics/AnalyticsTooltip";
import { CoinDataPoint } from "src/components/Referral-partner/Analytics/analyticsTypes";

const COLORS = ["#ffca59", "#ffae58", "#bce0a4", "#d4e3db", "#a0cfdd", "#a1a1ea", "#e66d79"];

const CenterIcon = (props: any) => {
  const { cx, cy } = props.viewBox;
  const coin = props.coin;
  const width = 50;
  const height = 50;
  const halfValue = width / 2;
  const match = coin.name.match(/\((.*?)\)/);

  return (
    <g>
      <foreignObject
        x={cx - halfValue} // Half the icon size to center
        y={cy - halfValue} // Half the icon size to center
        width={width} // Icon size
        height={height} // Icon size
      >
        {/* <CountryOrCryptoFlag size={height} name="BTC" /> */}
        <Icon name={match[1].toLowerCase()} size={height} />
      </foreignObject>
    </g>
  );
};

interface CustomerAssetsHeldProps {
  data: CoinDataPoint[];
}
const CustomerAssetsHeld = (props: CustomerAssetsHeldProps) => {
  const { data } = props;

  const mostHeldCoin = data.reduce((prev, current) =>
    prev.value > current.value ? prev : current,
  );

  const legendFormatter = (value: any) => {
    return value.split(" (")[0];
  };

  return (
    <ResponsiveContainer id="customer-holdings-chart" height="80%" width="95%">
      <PieChart>
        <Pie
          data={data}
          dataKey="value"
          nameKey="name"
          cx="50%"
          cy="50%"
          innerRadius={50} // Makes it a donut chart
          outerRadius={80}
          cornerRadius={3}
          paddingAngle={0}
          startAngle={90}
          endAngle={-270}>
          {data.map((_, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
          <Label content={<CenterIcon coin={mostHeldCoin} />} position="center" />
        </Pie>
        <Legend
          verticalAlign="bottom"
          height={36}
          iconSize={10}
          wrapperStyle={{
            fontSize: "10px",
          }}
          formatter={legendFormatter}
        />
        <Tooltip content={<AnalyticsTooltip chartName="customerAssetsHeld" />} />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default CustomerAssetsHeld;
